/*
 * „Pokaż więcej” pod nagłówkiem kolekcji / strony.
 *
 * Przycisk dokładamy TYLKO wtedy, gdy tekst naprawdę nie mieści się w trzech
 * wierszach — przy krótkim opisie zwijanie nie ma sensu i wyglądałoby na błąd.
 * Porównujemy `scrollHeight` z `clientHeight` w stanie zwiniętym.
 */
(function () {
  var STRZALKA =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg>';

  function wepnij(opis) {
    if (opis.dataset.opisGotowy) return;
    var tresc = opis.querySelector('[data-opis-tresc]');
    if (!tresc) return;
    opis.dataset.opisGotowy = '1';

    /*
     * Opis przychodzi już zwinięty z CSS — skrypt tylko sprawdza, czy jest co
     * chować, i dokłada przycisk. Odwrotna kolejność (zwijanie w JS) dawała
     * mrugnięcie pełnym tekstem przy każdym wejściu na stronę.
     */
    if (tresc.scrollHeight <= tresc.clientHeight + 4) {
      opis.classList.add('bez-zwijania');
      return;
    }

    var przycisk = document.createElement('button');
    przycisk.type = 'button';
    przycisk.className = 'naglowek-opis__przycisk';
    przycisk.setAttribute('aria-expanded', 'false');

    function opisz() {
      var rozwiniety = opis.classList.contains('jest-rozwiniety');
      przycisk.innerHTML = (rozwiniety ? 'Pokaż mniej' : 'Pokaż więcej') + STRZALKA;
      przycisk.setAttribute('aria-expanded', rozwiniety ? 'true' : 'false');
    }
    opisz();

    przycisk.addEventListener('click', function () {
      opis.classList.toggle('jest-rozwiniety');
      opisz();
    });

    opis.appendChild(przycisk);
  }

  function start() {
    document.querySelectorAll('[data-opis-zwijany]').forEach(wepnij);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', start);
})();
